/**
 * Process bulk-upload / validate API helpers (maps `error_rows` to `file_data` indices).
 */

/**
 * 0-based index into validation `file_data` for an `error_rows` entry.
 * Prefers `file_data_index` from the API; falls back to `row_number - 1` when aligned with line items.
 */
export function resolveProcessErrorFileDataIndex(rowError) {
  const raw = rowError?.file_data_index;
  if (raw !== undefined && raw !== null && raw !== '') {
    const n = Number(raw);
    if (Number.isFinite(n) && n >= 0) return n;
  }
  const rn = rowError?.row_number;
  if (rn !== undefined && rn !== null && rn !== '') {
    const n = Number(rn);
    if (Number.isFinite(n) && n >= 1) return n - 1;
  }
  return null;
}

function normalizeCellError(e) {
  return {
    column: String(e?.column ?? '').trim(),
    reason: String(e?.reason ?? e?.message ?? '').trim(),
  };
}

/** Build map: file_data index -> list of { column, reason } for ProcessDraftReviewTable. */
export function mapProcessValidationErrorsByFileDataIndex(errorRows) {
  return (Array.isArray(errorRows) ? errorRows : []).reduce((byRow, rowError) => {
    const idx = resolveProcessErrorFileDataIndex(rowError);
    if (idx == null || idx < 0) return byRow;
    const next = (Array.isArray(rowError?.errors) ? rowError.errors : []).map(normalizeCellError);
    return { ...byRow, [idx]: [...(byRow[idx] || []), ...next] };
  }, {});
}
